import React, { useState, useEffect } from "react";
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  IconButton,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  DialogActions,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

import plansApi from "../../hooks/GET/plans";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function SubscriptionPlanDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // props value
  const { open, handleClose } = props;

  // plans list logic start
  const [plansList, setPlansList] = useState([]);

  useEffect(() => {
    plansApi()
      .then((data) => {
        const subscriptionPlans = data.filter(
          (obj) => obj.planBillingInterval !== 0
        );
        setPlansList(subscriptionPlans);
      })
      .catch((error) => console.log(error));
  }, []);
  // plans list logic end

  //selected plans state logic start
  const [selectedPlan, setSelectedPlan] = useState("");

  const handleSelectedPlanChange = (e) => {
    setSelectedPlan(e.target.value);
  };
  //selected plans state logic end

  // handle submit logic start
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const requestBody = {
      planId: JSON.parse(selectedPlan).id,
    };
    setSubmitBtnLoading(true);
    axios
      .post(`${endpoint}/api/subscription`, requestBody)
      .then((res) => res.data)
      .then((data) => {
        setSubmitBtnLoading(false);
        handleClose();
        window.location = data.stripeUrl;
      })
      .catch((error) => {
        setSubmitBtnLoading(false);
        if (error.response) {
          customToast.error(error.response.data?.message);
        } else {
          customToast.error(error.message);
        }
      });
  };
  // handle submit logic end

  // reset logic start
  useEffect(() => {
    if (open) {
      setSelectedPlan("");
    }
  }, [open]);
  // reset logic end

  return (
    <Dialog
      open={open}
      scroll="paper"
      fullScreen={fullScreen}
      fullWidth
      TransitionComponent={Transition}
    >
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>Plans</Grid>
          <Grid item>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers sx={{ overflow: "auto" }}>
        <Typography variant="h6" align="center">
          Choose an Option
        </Typography>
        <Grid
          container
          component={RadioGroup}
          value={selectedPlan}
          onChange={handleSelectedPlanChange}
          sx={{ minWidth: 400 }}
        >
          {plansList.map((option, idx) => (
            <Grid
              item
              key={idx}
              xs={12}
              component={Paper}
              variant="outlined"
              sx={{
                padding: 2,
                marginTop: 2,
                borderColor:
                  JSON.stringify(option) === selectedPlan
                    ? "secondary.main"
                    : "",
              }}
            >
              <FormControlLabel
                value={JSON.stringify(option)}
                control={<Radio color="secondary" />}
                sx={{ width: "100%" }}
                disableTypography
                label={
                  <Grid container alignItems="center">
                    <Grid item xs={6}>
                      <Typography>{option.planName}</Typography>
                      <Typography vairant="caption" color="text.secondary">
                        {option.planDescription}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography align="right" sx={{ paddingRight: 2 }}>
                        {option.planBillingInterval} months
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      sx={{
                        paddingLeft: 1,
                        textAlign: "right",
                        borderLeft: 1,
                        borderColor:
                          JSON.stringify(option) === selectedPlan
                            ? "secondary.main"
                            : "text.secondary",
                      }}
                    >
                      <Typography variant="caption">Price</Typography>
                      <Typography
                        color="secondary.main"
                        sx={{ textTransform: "uppercase" }}
                      >
                        {option.planPrice} {option.planCurrecyIsoCode}
                      </Typography>
                    </Grid>
                  </Grid>
                }
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          size="large"
          color="secondary"
          variant="contained"
          fullWidth
          disabled={!selectedPlan}
          loading={submitBtnLoading}
          onClick={handleSubmit}
        >
          Proceed
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
